/**
 *  Notifications.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 06/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system
import React, { Component } from "react";

// template
import { Grid, Row, Col,FormGroup, FormControl, ControlLabel } from "react-bootstrap";

// components
import { Card } from "../../components/Card/Card.jsx";
import Select from 'react-select'

// notifications
import NotificationSystem from "react-notification-system";

// style
import './style.css';
import { style } from "../../variables/Variables.jsx";

// global
var firebase = require("../../firebase");

class Notifications extends Component{
    
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            message: '',
            topic: 'all',
            freeCodes: [],
            _notificationSystem: null,
            dddOptions: [
                { value: '+5547', label: '47' },
                { value: '+5548', label: '48' },
                { value: '+5549', label: '49' },
                { value: '+5561', label: '61' },
                { value: '+5567', label: '67' },
                { value: '+5582', label: '82' }
            ],
            dddVals: []
        };
    }

    componentDidMount() {
        document.title = "Security Care | Enviar Notificações";
        this.setState({ _notificationSystem: this.refs.notificationSystem });

        firebase.database.ref('/activationCodes/freeCode').once('value').then(snapshot => {
            const initialFreeCodes = snapshot.val();
            for(const key in initialFreeCodes) {
                this.setState({freeCodes:[...this.state.freeCodes, key]});
            }
        });
    }

    handleChange = (evt) => {
        this.setState({ [evt.target.name]: evt.target.value });
    }

    dddHandleChange = (dddVals) => {
        this.setState({ dddVals });
    }

    sendPush = () => {
        let {title, message, dddVals} = this.state;

        fetch('https://us-central1-brasil-mais-seguro.cloudfunctions.net/send_message_users', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                    'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                title,
                body: message,
                dddVals
            })
        }).then(response => response.json()).then(json => {
            this.setState({ value: ''});
            console.log('Mensagem enviada com sucesso!'+json);
            this.notify('Mensagem enviada com sucesso!', 'success');
            this.setState({title: '', message: ''});
        }).catch(error => {
            this.notify('Erro ao enviar, por favor tente novamente', 'error');
            console.log("Erro ao enviar, por favor tente novamente."+error);
        });
        console.log('Enviando... Por favor aguarde!', title, message);
    }

    notify = (message, level) =>  {
        this.state._notificationSystem.addNotification({
          title: <span data-notify="icon" className="pe-7s-bell" />,
          message: <div>{message}</div>,
          level: level,
          position: "tr",
          autoDismiss: 10
        });
    }

    render() {
        return (
            <div className="content bg-content">
                <NotificationSystem ref="notificationSystem" style={style} />
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                title="ENVIAR NOTIFICAÇÃO"
                                content={
                                <div>
                                    <div className='form-group'>
                                        <FormGroup controlId="formControlsTextarea">
                                            <ControlLabel>DDD</ControlLabel>
                                            <Select isMulti name='ddd' options={this.state.dddOptions} onChange={this.dddHandleChange} />
                                        </FormGroup>
                                    </div>

                                    <div className='form-group'>
                                        <FormGroup controlId="formControlsTextarea">
                                            <ControlLabel>Titulo</ControlLabel>
                                            <FormControl componentClass='input' placeholder='Título da mensagem...' name='title' value={this.state.title} onChange={this.handleChange} />
                                        </FormGroup>
                                    </div>

                                    <div className='form-group'>
                                        <FormGroup controlId="formControlsTextarea">
                                            <ControlLabel>Mensagem</ControlLabel>
                                            <FormControl componentClass='textarea' placeholder='Mensagem...' name='message' value={this.state.message} onChange={this.handleChange} />
                                        </FormGroup>
                                    </div>
                                    
                                    <div class="form-group">
                                        <button type="button" class="btn btn-info labelless pull-right" style={{fontWeight: 'bold'}} onClick={this.sendPush}>
                                            <span class="glyphicon glyphicon-send"></span> ENVIAR NOTIFICAÇÃO
                                        </button>
                                    </div>
                                    <div className="clearfix" />
                                </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        )
    };
}

export default Notifications;



// WEBPACK FOOTER //
// ./src/views/Notifications/Notifications.jsx